var Linker = require("../linker");

module.exports = function(library, destinations, deployer) {
  return async function() {
    await Linker.link(library, destinations, deployer);
  };
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-deployer/src/actions/link.js
// module id = 2764
// module chunks = 0 1